import React, { FC } from 'react'

interface Props {
  author: string
  stars: 1 | 2 | 3 | 4 | 5
  content: string
  date: string
}

const Review: FC<Props> = ({ author, stars, content, date }) => (
  <div className="bg-light-blue p-0 p-lg-3 mt-4 position-relative d-none d-md-flex align-items-center">
    <div className="reviews-single-slide-inner p-3">
      <div className="d-flex">
        <span className="review-author flex-grow-1 pr-2">{author}</span>
        <div className="review-stars pt-1 pb-2">
          {[...new Array(stars)].map((_, idx) => (
            <i key={`star-${idx}`} className="icon-star text-primary" />
          ))}
        </div>
      </div>
      <p className="review-content">{content}</p>
    </div>

    <div className="review-date position-absolute bg-white px-3 py-1">{date}</div>
  </div>
)

export default Review
